import { useState, useEffect } from 'react';
import { estadosSiglas } from './estadosBrasil';

/**
 * Recebe uma string e valida se esta dentro da regra de Negócio para CNPJ:
 * @param {string} cnpj string a ser checado.
 */
export function validateCPF(strCPF: string) {
  if (strCPF) {
    const cleanCpf = strCPF.replace(/[^\d]/g, '');

    if (cleanCpf.length !== 11) {
      return false;
    }

    // Verifica se todos os dígitos são iguais (ex: 00000000000)
    if (/^(\d)\1+$/.test(cleanCpf)) {
      return false;
    }

    const calcDigit = (slice: string): number => {
      let sum = 0;
      let factor = slice.length + 1;

      for (let i = 0; i < slice.length; i++) {
        sum += parseInt(slice[i]) * factor;
        factor--;
      }

      const mod = sum % 11;
      const digit = mod < 2 ? 0 : 11 - mod;

      return digit;
    };

    const firstDigit = calcDigit(cleanCpf.slice(0, 9));
    if (parseInt(cleanCpf[9]) !== firstDigit) {
      return false;
    }

    const secondDigit = calcDigit(cleanCpf.slice(0, 10));
    if (parseInt(cleanCpf[10]) !== secondDigit) {
      return false;
    }

    return true;
  }
  return false;
}

/**
 * Recebe uma string e valida se esta dentro da regra de Negócio para CNPJ:
 * @param {string} cnpj string a ser checado.
 */
export function validateCNPJ(cnpj: string): boolean {
  if (cnpj) {
    const cleanCnpj = cnpj.replace(/[^\d]/g, '');

    if (cleanCnpj.length !== 14) {
      return false;
    }

    // Verifica se todos os dígitos são iguais (ex: 00000000000000)
    if (/^(\d)\1+$/.test(cleanCnpj)) {
      return false;
    }

    const calcDigit = (slice: string, factor: number): number => {
      let sum = 0;

      for (let i = 0; i < slice.length; i++) {
        sum += parseInt(slice[i]) * factor;
        factor--;
        if (factor === 1) {
          factor = 9;
        }
      }

      const mod = sum % 11;
      const digit = mod < 2 ? 0 : 11 - mod;

      return digit;
    };

    const firstDigit = calcDigit(cleanCnpj.slice(0, 12), 5);
    if (parseInt(cleanCnpj[12]) !== firstDigit) {
      return false;
    }

    const secondDigit = calcDigit(cleanCnpj.slice(0, 13), 6);
    if (parseInt(cleanCnpj[13]) !== secondDigit) {
      return false;
    }

    return true;
  }
  return false;
}
/**
 * Recebe um string e valida se esta dentro da regra de Negócio para CEP:
 * @param {string} cep string a ser checado no if.
 */
export function validarCEP(cep: string) {
  cep = cep.replace(/\D/g, '');
  if (cep.length !== 8) return false;
  const validCEP = /^[0-9]{8}$/;
  return validCEP.test(cep);
}

/**
 * Recebe um string e retorna a mascara conforme o case:
 * @param {string} tipo string caso.
 */
export function maskInput(tipo: string) {
  switch (tipo) {
    case 'cep':
      return '99.999-999';
    case 'telefone':
      return '+55 (99) 9 9999-9999';
    case 'whatsapp':
      return '+55 (99) 9 9999-9999';
    default:
      return undefined;
  }
}

/**
 * Recebe um number e retorna true caso a largura da view for menor ou igual:
 * @param {number} size number para validação.
 */
export function useScreenSize(size = 768, greaterThan = false) {
  const [isLessThanSize, setIsLessThanSize] = useState(false);

  useEffect(() => {
    function onResize() {
      if (!greaterThan) {
        if (window.innerWidth < size) {
          setIsLessThanSize(true);
        } else {
          setIsLessThanSize(false);
        }
      } else {
        if (window.innerWidth > size) {
          setIsLessThanSize(true);
        } else {
          setIsLessThanSize(false);
        }
      }
    }

    window.addEventListener('resize', onResize);
    onResize();

    return () => window.removeEventListener('resize', onResize);
  }, [size]);

  return isLessThanSize;
}

/**
 * Recebe uma string e valida se está no formato válido de email:
 * @param {string} email string para validação.
 */
export function validateEmail(email: string) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

/**
 * Recebe uma string e valida qual estado ela se refere
 * @param {string} sigla string para validação.
 */
export function getEstadoFromSigla(sigla: string) {
  // Itera pelas chaves do objeto estadosSiglas
  for (const estado in estadosSiglas) {
    // Verifica se a sigla é igual à sigla do estado atual
    if (estadosSiglas[estado] === sigla) {
      // Retorna o estado correspondente
      return estado;
    }
  }

  // Caso não encontre correspondência, retorna null ou um valor padrão de sua escolha
  return null;
}
